/**
 * The default color fill.
 * @type {String}
 */
const DEFAULT_FILL = '#000';

/**
 * The default color opacity.
 * @type {String}
 */
const DEFAULT_OPACITY = '1';

/**
 * The default stroke width.
 * @type {String}
 */
const DEFAULT_STROKE_WIDTH = '1';

/**
 * The "none" fill value
 * @type {string}
 */
const FILL_NONE = 'none';

/**
 * The "transparent" color value
 * @type {string}
 */
const TRANSPARENT_COLOR = 'transparent';

/**
 * HEX color without opacity regular expression
 * @type {string}
 */
const HEX_REGEXP = /#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})/;

module.exports = {
    DEFAULT_FILL,
    DEFAULT_OPACITY,
    DEFAULT_STROKE_WIDTH,
    FILL_NONE,
    TRANSPARENT_COLOR,
    HEX_REGEXP
};
